module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/int.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_c('strong', [_vm._v("PROJECTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec1"
    }
  }, [_c('strong', [_vm._v("The Bunny Bunch ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec2"
    }
  }, [_c('strong', [_vm._v("Bertie and Beatrice the Birds ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec3"
    }
  }, [_c('strong', [_vm._v("Frederick the Frog Prince")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec4"
    }
  }, [_c('strong', [_vm._v("Babushkas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec5"
    }
  }, [_c('strong', [_vm._v("Three Hungry Bears")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec6"
    }
  }, [_c('strong', [_vm._v("Polly Dolly’s Dress-up Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec7"
    }
  }, [_c('strong', [_vm._v("Simon Snake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec8"
    }
  }, [_c('strong', [_vm._v("Piggies at Play")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec9"
    }
  }, [_c('strong', [_vm._v("Mischievous Mice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec10"
    }
  }, [_c('strong', [_vm._v("Eddie the Friendly Elephant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec11"
    }
  }, [_c('strong', [_vm._v("Three Little Fish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec12"
    }
  }, [_c('strong', [_vm._v("Peter Penguin’s Fishing Trip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#sec13"
    }
  }, [_c('strong', [_vm._v("The Owl and the Pussycat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_c('strong', [_vm._v("TECHNIQUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec1"
    }
  }, [_c('strong', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec2"
    }
  }, [_c('strong', [_vm._v("Casting on")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec3"
    }
  }, [_c('strong', [_vm._v("The knit and purl stitches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec4"
    }
  }, [_c('strong', [_vm._v("Basic stitch patterns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec5"
    }
  }, [_c('strong', [_vm._v("Binding off")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec6"
    }
  }, [_c('strong', [_vm._v("Shaping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec7"
    }
  }, [_c('strong', [_vm._v("Knitting in the round")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec8"
    }
  }, [_c('strong', [_vm._v("Colourwork")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec9"
    }
  }, [_c('strong', [_vm._v("Making up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec10"
    }
  }, [_c('strong', [_vm._v("Finishing touches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bm1.htm"
    }
  }, [_vm._v("Templates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bm2.htm"
    }
  }, [_vm._v("Yarns used")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bm3.htm"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ata.htm"
    }
  }, [_vm._v("About the author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ind.htm"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 66
// module chunks = 0